import { render, staticRenderFns } from "./ProjectTypeEditForm.vue?vue&type=template&id=d2719a08&"
import script from "./ProjectTypeEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports